<template>
    <div>
        <!-- Field Label -->
        <label :for="field.id" class="block text-sm font-medium text-gray-700 mb-2">
            {{ field.label }}
            <span v-if="field.required" class="text-red-500 ml-1">*</span>
        </label>

        <!-- Checkboxes -->
        <div v-for="(option, index) in field.options" :key="index" class="flex items-center mb-2">
            <input type="checkbox" :id="`${field.id}_${index}`" :value="option"
                class="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                :checked="parsedModelValue.includes(option)" @change="onCheckboxChange($event, option)" />
            <label :for="`${field.id}_${index}`" class="ml-3 text-gray-700">
                {{ option }}
            </label>
        </div>

        <!-- Field Description -->
        <p v-if="field.description" class="text-xs text-gray-500 mt-1">
            {{ field.description }}
        </p>

    </div>
</template>


<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: [Array, String, null], // Model value can be an array, string, or null
            default: () => [],
        },
        errorMessage: {
            type: String,
            default: '',
        }
    },
    computed: {
        parsedModelValue() {
            // Check if modelValue is a string and parse it, otherwise use it directly as an array
            if (typeof this.modelValue === 'string') {
                try {
                    return JSON.parse(this.modelValue);
                } catch (e) {
                    return [];
                }
            }
            return Array.isArray(this.modelValue) ? this.modelValue : [];
        }
    },
    methods: {
        onCheckboxChange(event, option) {
            let newValue = [...this.parsedModelValue]; // Use parsed model value
            if (event.target.checked) {
                newValue.push(option); // Add the option if checked
            } else {
                newValue = newValue.filter(item => item !== option); // Remove if unchecked
            }
            this.$emit('update:modelValue', newValue); // Emit updated value as array
        },
    },
};
</script>
